module.exports = __webpack_public_path__ + "img/act-储备人才.e6f0c1cd.png";